import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "@/components/temple/Loader";
import Hero from "@/components/temple/Hero";
import Marquee from "@/components/temple/Marquee";
import Manifesto from "@/components/temple/Manifesto";
import Gates from "@/components/temple/Gates";
import WhereToBegin from "@/components/temple/WhereToBegin";
import Matrix from "@/components/temple/Matrix";
import Vessels from "@/components/temple/Vessels";
import Ritual from "@/components/temple/Ritual";
import Evolutions from "@/components/temple/Evolutions";
import Books from "@/components/temple/Books";
import Ariel from "@/components/temple/Ariel";
import Consent from "@/components/temple/Consent";
import Enter from "@/components/temple/Enter";
import Workshops from "@/components/temple/Workshops";
import { takeIntroDelay } from "@/lib/intro";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const [delay] = useState(takeIntroDelay);
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 350);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      {delay > 1 && <Loader />}
      <main>
        <Hero delay={delay} />
        <Marquee />
        <Manifesto />
        <WhereToBegin />
        <Gates />
        <Matrix />
        <Vessels />
        <Ritual />
        <Evolutions />
        <Books />
        <Ariel />
        <Consent />
        <Workshops />
        <Enter />
      </main>
    </>
  );
}
